<template>
  <div class="van-search">
    <div class="van-search__content van-search__content--square">
      <div class="van-cell van-cell--borderless van-field">
        <div class="van-field__left-icon">
          <i class="van-icon van-icon-search"></i>
        </div>
        <div class="van-cell__value van-cell__value--alone van-field__value">
          <div class="van-field__body">
            <input type="search" :placeholder="placeholder" @input="$emit('input',$event.target.value)" @keypress="$emit('keypress',$event)" :value="value" class="van-field__control"></input>
            <i v-if="value" class="van-icon van-icon-clear van-field__clear" @click="$emit('clearValue',value)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props:{
        placeholder:{
          type:String,
        },
        value:{
          type:String,
        },
      },
    }
</script>

<style scoped>
  @import "../../../static/css/vant.css";
</style>



// WEBPACK FOOTER //
// src/components/common/Search.vue